$(document).ready(function () {
  if ($('.video-slider-section').length) {
    const prevArrow = `
    <button type="button" class="slick-prev">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="#135756">
        <path d="M60 30.0015C60 46.5566 46.5573 60 30 60C13.4427 60 -2.63944e-06 46.5566 -1.19215e-06 30.0015C2.55413e-07 13.4434 13.4427 -2.55473e-07 30 1.19201e-06C46.5573 2.6395e-06 60 13.4434 60 30.0015ZM35.3621 44.5341C35.7852 44.8582 36.2623 45.0053 36.7303 45.0053C37.8976 45.0053 38.9958 44.087 38.9958 42.7577L38.9958 17.2483C38.9958 15.913 37.8946 14.9977 36.7303 14.9977C36.2593 14.9977 35.7822 15.1478 35.3591 15.4749C30.6961 19.0848 22.7596 25.2333 18.8618 28.2521C18.3097 28.6782 17.9916 29.3323 17.9916 30.0285C17.9916 30.7187 18.3127 31.3758 18.8648 31.8019L35.3621 44.5341Z"/>
      </svg>
    </button>
  `;
    const nextArrow = `
      <button type="button" class="slick-next">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="#135756">
          <path d="M0 29.9985C0 13.4434 13.4427 0 30 0C46.5573 0 60 13.4434 60 29.9985C60 46.5566 46.5573 60 30 60C13.4427 60 0 46.5566 0 29.9985ZM24.6379 15.4659C24.2148 15.1418 23.7377 14.9947 23.2697 14.9947C22.1024 14.9947 21.0042 15.913 21.0042 17.2423V42.7517C21.0042 44.087 22.1054 45.0023 23.2697 45.0023C23.7407 45.0023 24.2178 44.8522 24.6409 44.5251C29.3039 40.9152 37.2405 34.7667 41.1382 31.7479C41.6903 31.3218 42.0084 30.6677 42.0084 29.9715C42.0084 29.2813 41.6873 28.6242 41.1352 28.1981L24.6379 15.4659Z"/>
        </svg>
      </button>
    `;

    $('.video-slider')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 3,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30px',
              arrows: false,
            },
          },
        ],
      });
  }
});
